// @ts-ignore
import { $set, update } from 'qim';
import _ from 'lodash';
import { exists, get, superHumanize } from '@zapier/common-utils';
import { ServiceAction } from '../types';

const normalizeActions = (actions: ServiceAction[]): ServiceAction[] => {
  actions = actions.slice(0);
  if (!_.some(actions, action => get(action, ['important'], undefined))) {
    return actions.map(action => {
      const label = exists(action.label)
        ? action.label
        : superHumanize(action.key ?? '');
      return update(
        [
          ['label', $set(label)],
          ['important', $set(true)],
        ],
        action
      );
    });
  }
  return actions;
};

const visibleActions = (actions: ServiceAction[], currentSelection: any) => {
  return _.filter(actions, action => {
    return (
      get(action, ['key'], undefined) === currentSelection ||
      !get(action, ['hide'], undefined)
    );
  });
};

const parseActions = (actions: ServiceAction[], currentSelection: any) => {
  /* special parsing rules to help the frontend.
   * 1. if all fields are `important`: false or not defined, set them all to true
   * 2. give every action a label if it doesnt have one
   * 3. strip hidden actions (unless it is currently selected one)
   */
  actions = normalizeActions(actions);
  return visibleActions(actions, currentSelection);
};

export default function getActionMeta(
  actions: ServiceAction[],
  actionKey: string
) {
  actions = parseActions(actions, actionKey);
  return _.find(actions, action => action.key === actionKey);
}
